
export default {
  name: 'ResourceTableItemSpecifics',
  props: {
    specifics: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      spreadedSpecifics: {},
      email: '',
      googleMapLoaded: false,
    }
  },

  computed: {
    physicalLocation() {
      if (!this.specifics.contactDetails) return

      const details = this.specifics.contactDetails.find((details) => {
        return (
          details.isConfidential === false &&
          details.contact.type === 'PhysicalLocation'
        )
      })

      return details ? details.contact : null
    },

    postalAddress() {
      if (!this.specifics.contactDetails) return

      const details = this.specifics.contactDetails.find((details) => {
        return (
          details.isConfidential === false &&
          details.contact.type === 'PostalAddress'
        )
      })

      return details ? details.contact : null
    },

    phoneNumber() {
      if (!this.specifics.contactDetails) return

      const details = this.specifics.contactDetails.find((details) => {
        return (
          details.isConfidential === false &&
          details.contact.type === 'PhoneNumber'
        )
      })

      if (details && details.contact && details.contact.number !== '0') {
        return details.contact
      }

      return null
    },

    website() {
      if (!this.specifics.contactDetails) return

      const details = this.specifics.contactDetails.find((details) => {
        return (
          details.isConfidential === false && details.contact.type === 'Website'
        )
      })

      return details ? details.contact : null
    },

    googleMapsExternalHref() {
      if (!this.physicalLocation || !this.specifics._geoloc) return null

      const { line1, city, stateProvince } = this.physicalLocation

      if (line1 && city && stateProvince) {
        return this.renderGoogleMapsUrl(`${line1} ${city}, ${stateProvince}`)
      }

      const { lat, lng } = this.specifics._geoloc

      if (!lat || !lng) return null

      return this.renderGoogleMapsUrl(`${lat},${lng}`)
    },

    googleMapsEmbeddedUri() {
      if (!this.physicalLocation || !this.specifics._geoloc) return null

      const { line1, city, stateProvince } = this.physicalLocation

      if (line1 && city && stateProvince) {
        return this.renderGoogleMapsUrl(
          `${line1} ${city}, ${stateProvince}`,
          true
        )
      }

      const { lat, lng } = this.specifics._geoloc

      if (!lat || !lng) return null

      return this.renderGoogleMapsUrl(`${lat},${lng}`, true)
    },
  },

  methods: {
    async onEmailResource() {
      if (this.email) {
        try {
          await this.$api.ltng.forms
            .postFormSubmit({
              account_id: this.$config.ltngId,
              form_id: 'send_resource',
              data: {
                recipient_email: this.email,
                resource_id: this.specifics.id,
              },
            })
            .then((response) => {
              if (response.data.success) {
                this.email = ''
                this.$toasted.success('Resource sent successfully')
              }
            })
        } catch (error) {
          this.$toasted.error(error)
        }
      }
    },

    onBackToResources() {
      document.getElementById('resource-list').focus()
    },

    renderGoogleMapsUrl(query, embedded = false) {
      if (embedded) {
        return `
          https://www.google.com/maps/embed/v1/search?key=AIzaSyBlDsJCFKuM0qBjeYU8p0ARr9yYyaKH2z0&q=${encodeURIComponent(
            query
          )}
        `
      }

      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        `${query}`
      )}`
    },
  },
}
